// frontend/client/src/services/api/rail.service.ts

  import { 
    RailUserInfoUpdateRequest, 
    RailDataCompleteness, 
    RailApplicationStatusResponse,
    // RailAccount,
    RailAccountsDataResponse,
    CreateFiatData,
    RailCounterpartiesDataResponse,
    RailCounterpartyDataResponse,

  } from '../../types/rail.types';
  import {CounterPartyData} from '../../types/counterparties.types'
  import { getServerUrl } from '../../config/server.config';

  class MainService {
    private async request<T>(endpoint: string, options?: RequestInit): Promise<T> {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');

      if (!token) {
        throw new Error('Authentication token not found');
      }

      const API_URL = getServerUrl(true); // true para incluir /api
      const url = `${API_URL}${endpoint}`;
      
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        ...options?.headers
      };
  
      // try {
        const response = await fetch(url, {
          ...options,
          headers,
          credentials: 'include' // Th
        });
        return await response.json();
    }
  
    // Verificar completitud de datos para Rail
    async checkDataCompleteness(): Promise<RailDataCompleteness> {

      const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
      const userInfo = userStr ? JSON.parse(userStr) : null;
      const clientType = userInfo?.clientApplication?.type;
       if (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE') {
         return {
          complete: true,
          missingFields: [],
          data: {
            clientApp: {},
            railInfo: {}
          }
        } as any; // Usar 'any' para evitar problemas de tipos
       }
      return this.request<any>('/rail/individual/check-completeness')
        .then(response => {
          if (!response.success) {
            throw new Error(response.message || 'Failed to check data completeness');
          }
          return response;
        });
    }

    // Actualizar información adicional para Rail
    async updateUserInfo(userInfo: RailUserInfoUpdateRequest): Promise<{ success: boolean; message: string }> {
      return this.request<any>('/rail/individual/update-missing-data', {
        method: 'POST',
        body: JSON.stringify(userInfo)
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to update user information');
        }
        return response;
      });
    }
  
    // Crear una cuenta USD
    async createMainAccount(): Promise<any> {
     
     return this.request<any>('/support/zenus/request', {
        method: 'POST',
        body: JSON.stringify( {
              "language": "en" 
         })
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to update user information');
        }
        return response;

      });
    }
    // Obtener todas las cuentas del usuario
    async getMainWallets(virtualDash:any): Promise<RailAccountsDataResponse> {
      // DEPRECATED: Este método ya no se usa en V2
      // Los datos ahora vienen de Redux (getZenusAccount, getMasterCardData, getCryptoWallets)
      // Retornamos estructura vacía para evitar errores
      return Promise.resolve({
        success: true,
        accounts: {
          fiat: [],
          crypto: []
        }
      } as any);
    }
  
    // Obtener detalles de una cuenta específica
    async getAccountDetails(applicationId: string): Promise<{ success: boolean; data: any }> {
      return this.request<any>(`/rail-operations/accounts/${applicationId}`)
        .then(response => {
          if (!response.success) {
            throw new Error(response.message || 'Failed to get account details');
          }
          return response;
        });
    }
  
    // Obtener estado de una cuenta específica
    async getAccountStatus(applicationId: string): Promise<RailApplicationStatusResponse> {
      return this.request<RailApplicationStatusResponse>(`/rail-operations/accounts/${applicationId}/status`)
        .then(response => {
          if (!response.success) {
            throw new Error(response.message || 'Failed to get account status');
          }
          return response;
        });
    }
  
    // Subir documentos del usuario a Rail
    async uploadDocuments(applicationId: string): Promise<{ success: boolean; message: string; data?: any }> {
      return this.request<any>(`/rail-operations/accounts/${applicationId}/documents/upload`, {
        method: 'POST'
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to upload documents');
        }
        return response;
      });
    }
  
    // Enviar una Application para procesamiento
    async submitApplication(applicationId: string): Promise<{ success: boolean; message: string }> {
      // Obtener tipo de usuario
      const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
      const userInfo = userStr ? JSON.parse(userStr) : null;
      const clientType = userInfo?.clientApplication?.type;
      
      // Determinar endpoint según tipo de cliente
      const endpoint = (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE')
        ? `/rail/corporate/${applicationId}/submit`
        : `/rail/individual/${applicationId}/submit`;
      
      return this.request<any>(endpoint, {
        method: 'POST'
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to submit application');
        }
        return response;
      });
    }
    async getCounterpartiesData(): Promise<RailCounterpartiesDataResponse>{
      return this.request<any>('/rail-operations/my-counterparties')
      .then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to get user accounts');
        }
        return response;
      });
    }
    async getCounterpartyData(counterpartyId:string): Promise<RailCounterpartyDataResponse>{
      return this.request<any>(`/rail-operations/counterparties/${counterpartyId}`)
        .then(response => {
          if (!response.success) {
            throw new Error(response.message || 'Failed to get account details');
          }
          return response;
        });
    }
    async createCounterparty(createData:any){
      return this.request<string>('/rail-operations/counterparties', {
        method: 'POST',
        body: JSON.stringify(createData),
      }).then(response => {
        return response;
      });
      
    }
    async getCustomerDetailsData(customerId:string): Promise<RailCounterpartiesDataResponse>{
      return this.request<any>(`/rail-operations/my-counterparties?customer_id=${customerId}`)
      .then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to get user accounts');
        }
        return response;
      });
    }

    //  async createRailTicket(currency: string): Promise<any> {
    //   // Obtener tipo de usuario
    //   const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
    //   const userInfo = userStr ? JSON.parse(userStr) : null;
    //   const clientType = userInfo?.clientApplication?.type;
      
    //   // Determinar endpoint según tipo de cliente
    //   const endpoint = (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE')
    //     ? '/rail/corporate/create-ticket'
    //     : '/rail/individual/create-ticket';
      
    //   return this.request<any>(endpoint, {
    //     method: 'POST',
    //     body: JSON.stringify({ currency })
    //   }).then(response => {
    //     if (!response.success) {
    //       throw new Error(response.message || 'Failed to create ticket');
    //     }
    //     return response;
    //   });
    // }

    // // Crear aplicación desde ticket completado (individual o corporate)
    // async createApplicationFromTicket(): Promise<any> {
    //   // Obtener tipo de usuario
    //   const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
    //   const userInfo = userStr ? JSON.parse(userStr) : null;
    //   const clientType = userInfo?.clientApplication?.type;
      
    //   // Determinar endpoint según tipo de cliente
    //   const endpoint = (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE')
    //     ? '/rail/corporate/create-from-ticket'
    //     : '/rail/individual/create-from-ticket';
      
    //   return this.request<any>(endpoint, {
    //     method: 'POST',
    //     body: JSON.stringify({})
    //   }).then(response => {
    //     if (!response.success) {
    //       throw new Error(response.message || 'Failed to create application from ticket');
    //     }
    //     return response;
    //   });
    // }

    // Crear ticket para cuenta Rail (individual o corporate)
    async createRailTicket(currency: string): Promise<any> {
      // Obtener tipo de usuario
      const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
      const userInfo = userStr ? JSON.parse(userStr) : null;
      const clientType = userInfo?.clientApplication?.type;
      
      // Determinar endpoint según tipo de cliente
      const endpoint = (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE')
        ? '/rail/corporate/create-ticket'
        : '/rail/individual/create-ticket';
      
      return this.request<any>(endpoint, {
        method: 'POST',
        body: JSON.stringify({ currency })
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to create ticket');
        }
        return response;
      });
    }

    // Crear aplicación desde ticket completado (individual o corporate)
    async createApplicationFromTicket(): Promise<any> {
      // Obtener tipo de usuario
      const userStr = localStorage.getItem('user') || sessionStorage.getItem('user');
      const userInfo = userStr ? JSON.parse(userStr) : null;
      const clientType = userInfo?.clientApplication?.type;

      // Determinar endpoint según tipo de cliente
      const endpoint = (clientType === 'CORPORATE' || clientType === 'FAST_CORPORATE')
        ? '/rail/corporate/create-from-ticket'
        : '/rail/individual/create-from-ticket';

      return this.request<any>(endpoint, {
        method: 'POST',
        body: JSON.stringify({})
      }).then(response => {
        if (!response.success) {
          throw new Error(response.message || 'Failed to create application from ticket');
        }
        return response;
      });
    }

    // Métodos auxiliares para compatibilidad con crypto-wallet-manager
    async get(endpoint: string): Promise<any> {
      return this.request<any>(endpoint, {
        method: 'GET'
      });
    }

    async post(endpoint: string, data?: any): Promise<any> {
      return this.request<any>(endpoint, {
        method: 'POST',
        body: JSON.stringify(data)
      });
    }

    async put(endpoint: string, data?: any): Promise<any> {
      return this.request<any>(endpoint, {
        method: 'PUT',
        body: JSON.stringify(data)
      });
    }

    async delete(endpoint: string): Promise<any> {
      return this.request<any>(endpoint, {
        method: 'DELETE'
      });
    }

    async patch(endpoint: string, data?: any): Promise<any> {
      return this.request<any>(endpoint, {
        method: 'PATCH',
        body: JSON.stringify(data)
      });
    }
  }

  export const mainService = new MainService();